var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaintRoller(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456 72H448V120H456C460.375 120 464 123.625 464 128V184C464 210.4 442.4 232 416 232H256C225.072 232 200 257.072 200 288V320H192C174.375 320 160 334.375 160 352V480C160 497.6 174.4 512 192 512H256C273.6 512 288 497.6 288 480V352C288 334.375 273.625 320 256 320H248V288C248 283.625 251.625 280 256 280H416C469.02 280 512 237.02 512 184V128C512 97.072 486.928 72 456 72ZM416 144V48C416 21.5 394.5 0 368 0H48C21.5 0 0 21.5 0 48V144C0 170.5 21.5 192 48 192H368C394.5 192 416 170.5 416 144ZM48 48H368V144H48V48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintRoller);
export default __webpack_public_path__ + "static/media/paint-roller.c09614c9bdcc34a870414e09ec0abd1c.svg";
export { ForwardRef as ReactComponent };